import Service from "./Service"

class ProjectService extends Service {

    findById = (id) => this.get(`/projects/${id}`)

    findStructureById = (id) => this.get(`/projects/${id}/structure`)

    getBudgetOfProject = (id) => this.get(`/projects/${id}/budget`)

    getImportantProjects = () => this.get("/projects/importants")

    getComments = (id, queryParams) => this.getWithParams(`/projects/${id}/comments`, queryParams)

    search = (queryParams) => this.getWithParams("/projects", queryParams)

    searchProjectTasks = (queryParams) => this.getWithParams("/projects/project-tasks", queryParams)

    getSelectors = () => this.get("/projects/selectors")

    updateProjectBudget = (id, requestBody) => this.patch(`/projects/${id}/budget`, requestBody)

    updateProductProjects = (id, requestBody) => this.patch(`/projects/${id}/product-projects`, requestBody)

    updateProjectTasks = (id, requestBody) => this.patch(`/projects/${id}/project-tasks`, requestBody)

    updateProjectDetails = (id, requestBody) => this.patch(`/projects/${id}/details`, requestBody)

    updateDraftInvoices = (id, requestBody) => this.patch(`/projects/${id}/draft-invoices`, requestBody)

    toggleRelevance = (id) => this.patch(`/projects/${id}/relevance`)

    uploadProjectFiles = (id, files) => {
        const formData = new FormData();
        files.forEach(file => formData.append("files", file))
        return this.postAsFormData(`/projects/${id}/files`, formData)
    }

    deleteProject = (projectId) => this.del(`/projects/${projectId}`)

    deleteProjectFile = (id, fileId) => this.del(`/projects/${id}/files/${fileId}`)
}

const projectService = new ProjectService()
export default projectService